import { z } from "zod";

export type SignInToken = z.infer<typeof SignInTokenSchema>;
export const SignInTokenSchema = z.object({
  id: z.string().optional(),
  access_token_v2: z.string().optional(),
  refresh_token_v2: z.string().optional(),
  subscription_endpoint: z.string().optional(),
});
